import React from 'react';
import InvoiceList from './InvoiceList';
import {
    printCurrency,
} from '../util/formatUtility';
import { translateResourceString } from '../util/translationUtility';
import BraintreePaymentComponentWrapper from './BraintreeDropInPayment';
import { ERROR_USER_ALERT } from '../SharedComponents/UserMessaging/userAlertTypes';
import fetch from 'cross-fetch';
import BraintreeAchPayment from './BraintreeAchPayment';
import braintree from 'braintree-web';
import { capitalize } from 'lodash';
import invoiceEventBusClient from "../util/invoiceEventBusClient";

const creditCard = 'CreditCard';
const ach = 'ACH';
const invoiceCredit = 'InvoiceCredit';

class InvoicePayments extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            notes: '',
            braintreePaymentNonce: '',
            braintreePaymentPayload: null,
            paymentProcessing: false,
            selectedPaymentType: null,
            selectedBraintreeAchBankAccount: null,
            braintreeDeviceData: '',
            braintreeClientToken: '',
            vaulted: false,
            billingAddress: null,
            braintreeSaveCard: false
        };
    }

    componentDidMount() {
        this.fetchClientTokenAndDeviceData();
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.selectedPaymentType != this.state.selectedPaymentType
            || (!!prevState.braintreePaymentNonce && !this.state.braintreePaymentNonce)) {
            this.props.clearMessages();
        }
    }

    async fetchClientToken() {
        return fetch(this.props.braintreeClientTokenEndpoint, {
            credentials: 'same-origin',
            cache: 'no-cache',
            method: 'POST'
        })
            .then(response => response.json())
            .then(tokenResult => {
                return tokenResult.Token
            })
            .catch(error => {
                console.error(error.message)
            });
    }

    fetchClientTokenAndDeviceData() {
        this.fetchClientToken()
            .then(token => {
                if (!token) {
                    this.props.addMessage({ text: translateResourceString("/MyAccountPage/InvoicePayments/Payments/Errors/CouldNotLoadPaymentComponent"), type: ERROR_USER_ALERT });
                    return Promise.reject();
                }
                this.setState({ braintreeClientToken: token });
                return braintree.client.create({
                    authorization: token
                });
            })
            .then(clientInstance => {
                return braintree.dataCollector.create({
                    client: clientInstance,
                    kount: true
                })
            })
            .then(dataCollector => {
                this.setState({ braintreeDeviceData: dataCollector.deviceData })
            })
            .catch(e => {
                //console.error(e);
                this.props.addMessage({ text: translateResourceString("/MyAccountPage/InvoicePayments/Payments/Errors/CouldNotLoadPaymentComponent"), type: ERROR_USER_ALERT });
            })
    }

    braintreeDropInPaymentIsValid = (braintreePaymentNonce, braintreeDropInDeviceData) => {
        // Additional payment logic
        return braintreePaymentNonce && braintreePaymentNonce.length > 0 &&
            braintreeDropInDeviceData && braintreeDropInDeviceData.length > 0;
    }

    braintreeAchPaymentIsValid = (usBankAccount, usBankAccountDeviceData) => {
        // Additional payment logic
        return usBankAccount && usBankAccount.Token && usBankAccount.Token.length > 0 &&
            usBankAccountDeviceData && usBankAccountDeviceData.length > 0;
    }

    paymentProcessed = () => {
        invoiceEventBusClient.dispatch("paymentProcessed", {message: "payment processed"});
    }

    processPayment = (braintreePaymentNonce, usBankAccount, deviceData, selectedPaymentType, billingAddress, vaulted, braintreeSaveCard) => {
        this.props.clearMessages();
        this.setState({ paymentProcessing: true });

        let payInvoicesViewModel = {
            BraintreePaymentToken: usBankAccount && usBankAccount.Token ? usBankAccount.Token : "",
            BraintreePaymentNonce: braintreePaymentNonce,
            OrganizationId: this.props.selectedAccountOrganizationOption.OrganizationId,
            PaymentNotes: this.state.notes,
            DeviceData: deviceData,
            PaymentMethod: selectedPaymentType,
            InvoicePayments: this.props.selectedInvoices.map(inv => {
                const payment = {
                    OpenARId: inv.OpenARId,
                    Amount: inv.Balance > 0 ? Math.abs(inv.amountToPay) : -Math.abs(inv.amountToPay)
                };
                return payment;
            }),
            BillingAddress: billingAddress,
            Vaulted: vaulted,
            BraintreeSaveCard: braintreeSaveCard
        };

        fetch(this.props.payInvoicesEndpoint,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                credentials: 'same-origin',
                body: JSON.stringify(payInvoicesViewModel)
            })
            .then(async response => {
                const data = await response.json();

                if (!response.ok || !data.success) {
                    const error = (data && data.message) || response.status;
                    return Promise.reject(error);
                }

                this.paymentProcessed();
                //this.setState({ postId: data.id });
                this.props.setAndViewNewInvoicePayment(data.payment, data.paymentType);
            })
            .catch(error => {
                console.error(error);
                this.props.addMessage({ text: translateResourceString("/MyAccountPage/InvoicePayments/Payments/Errors/CouldNotProcessPayment"), type: ERROR_USER_ALERT });
            })
            .finally(() => {
                this.setState({ paymentProcessing: false });
            }); 
    }

    render() {
        const {
            braintreeClientSettings,
            braintreeClientTokenEndpoint,
            braintreeUsBankAccountEndpoint,
            navigateToView,
            addMessage,
            selectedInvoices,
            invoicesTotal,
            creditCardSurchargePercentage,
            selectedAccountOrganizationOption,
            states,
            usTwoLetterCountryCode,
            usThreeLetterCountryCode,
            paymentButtonText
        } = this.props;
        const {
            billingAddress,
            braintreePaymentNonce,
            braintreePaymentPayload,
            notes,
            paymentProcessing,
            selectedPaymentType,
            selectedBraintreeAchBankAccount,
            braintreeDeviceData,
            braintreeClientToken,
            vaulted,
            braintreeSaveCard
        } = this.state;

        const paymentIsValid = invoicesTotal === 0 ||
            (selectedPaymentType === creditCard && this.braintreeDropInPaymentIsValid(braintreePaymentNonce, braintreeDeviceData)) ||
            (selectedPaymentType === ach && this.braintreeAchPaymentIsValid(selectedBraintreeAchBankAccount, braintreeDeviceData));

        let total = invoicesTotal;
        let surcharge = 0;
        if (selectedPaymentType === creditCard) {
            surcharge = parseFloat((invoicesTotal * creditCardSurchargePercentage).toFixed(2));
            total = total + surcharge;
        }

        return (
            <div className="invoice-payments--payments">
                <h4 className="mb-4 headline headline-md">{translateResourceString("/MyAccountPage/InvoicePayments/Payments/Header")}</h4>
                <div className="row">
                    <div className="col-12">
                        <div className="bg-light-gray p-2 d-flex flex-wrap justify-content-between align-items-center mb-4">
                            <div className="fw-600">{translateResourceString("/MyAccountPage/InvoicePayments/Payments/InvoicesTotalLabel")} {printCurrency(invoicesTotal)}</div>
                            <button disabled={paymentProcessing} className="btn btn-cc-gray" onClick={() => navigateToView(0)}>{translateResourceString("/MyAccountPage/InvoicePayments/Payments/CancelPaymentButton")}</button>
                        </div>
                    </div>
                    <div className="col-md-8">

                        <div className="bg-light-gray p-2 mb-4">
                            <h5 className="headline headline-xs">{translateResourceString("/MyAccountPage/InvoicePayments/Payments/BillToHeader")}</h5>


                            {selectedAccountOrganizationOption &&
                                <React.Fragment>
                                    {selectedAccountOrganizationOption.Name}<br />
                                    {selectedAccountOrganizationOption.PayerId}
                                </React.Fragment>
                            }
                        </div>

                        {invoicesTotal > 0 && <React.Fragment>
                            <div className="bg-light-gray p-2 mb-4">
                                <h4 className="headline headline-xs mb-2">{translateResourceString("/MyAccountPage/InvoicePayments/Payments/SelectPaymentMethod")}</h4>
                                <div className={`payment-methods-selection`}>
                                    <div className="form-check text-sm">
                                        <input
                                            type="radio"
                                            value={creditCard}
                                            checked={selectedPaymentType === creditCard}
                                            onChange={(e) => this.setState({
                                                selectedPaymentType: e.target.value,
                                                selectedBraintreeAchBankAccount: null
                                            })}
                                            id="selected-payment-type-credit-card"
                                            className="form-check-input"
                                            disabled={paymentProcessing}
                                        />
                                        <label className="form-check-label ml-2" htmlFor="selected-payment-type-credit-card">
                                            {selectedPaymentType === creditCard && !!braintreePaymentPayload && !!braintreePaymentPayload.details
                                                ? translateResourceString("/MyAccountPage/InvoicePayments/Payments/CreditCardDescription", braintreePaymentPayload.details.lastFour) + " - " + translateResourceString("/MyAccountPage/InvoicePayments/Payments/SurchargeMessage")
                                                : translateResourceString("/MyAccountPage/InvoicePayments/Payments/CreditCard")
                                            }
                                        </label>
                                    </div>
                                    <div className={`${selectedPaymentType === creditCard ? "" : "d-none"} mt-1 mb-4`}>
                                        <BraintreePaymentComponentWrapper
                                            addMessage={addMessage}
                                            onPaymentCancel={() => navigateToView(0)}
                                            braintreeClientSettings={braintreeClientSettings}
                                            braintreeClientTokenEndpoint={braintreeClientTokenEndpoint}
                                            amount={total}
                                            braintreePaymentNonce={braintreePaymentNonce}
                                            updateBraintreePaymentData={(payload, billingAddress, saveCard) => this.setState({
                                                braintreePaymentNonce: payload ? payload.nonce : '',
                                                braintreePaymentPayload: payload,
                                                reinitBraintree: false,
                                                vaulted: payload && payload.vaulted !== undefined ? payload.vaulted : false,
                                                billingAddress: billingAddress,
                                                braintreeSaveCard: saveCard
                                            })}
                                            braintreeClientToken={braintreeClientToken}
                                            paymentProcessing={paymentProcessing}
                                            states={states}
                                            usTwoLetterCountryCode={usTwoLetterCountryCode}
                                            usThreeLetterCountryCode={usThreeLetterCountryCode}
                                        />
                                    </div>
                                    <div className="form-check text-sm">
                                        <input
                                            type="radio"
                                            value={ach}
                                            checked={selectedPaymentType === ach}
                                            onChange={(e) => this.setState({ selectedPaymentType: e.target.value })}
                                            id="selected-payment-type-ach"
                                            className="form-check-input"
                                            disabled={paymentProcessing}
                                        />
                                        <label className="form-check-label ml-2" htmlFor="selected-payment-type-ach">{translateResourceString("/MyAccountPage/InvoicePayments/Payments/ACH")}</label>
                                        {selectedBraintreeAchBankAccount && <span>&nbsp;{capitalize(selectedBraintreeAchBankAccount.Type)} {translateResourceString("/MyAccountPage/InvoicePayments/BraintreeAchPayment/EndingIn")} {selectedBraintreeAchBankAccount.Last4} <button disabled={paymentProcessing} className="btn btn-primary btn-xs" onClick={() => this.setState({ selectedBraintreeAchBankAccount: null })}>{translateResourceString("/MyAccountPage/InvoicePayments/Payments/Change")}</button></span>}
                                    </div>
                                    <div className={`${selectedPaymentType === ach && !selectedBraintreeAchBankAccount ? "" : "d-none"} mt-1 mb-1`}>
                                        <BraintreeAchPayment
                                            onSelect={(selected) => this.setState((prev) =>
                                            ({
                                                selectedBraintreeAchBankAccount: selected,
                                                selectedPaymentType: prev.selectedPaymentType || ach
                                            })
                                            )}
                                            braintreeUsBankAccountEndpoint={braintreeUsBankAccountEndpoint}
                                            onError={(message) => this.props.addMessage({ text: message, type: ERROR_USER_ALERT })}
                                        />
                                    </div>
                                </div>
                            </div>


                        </React.Fragment>
                        }

                        <div className="bg-light-gray p-2">
                            <InvoiceList
                                invoices={selectedInvoices}
                                invoicesTotal={invoicesTotal}
                                useSummaryView={true}
                            />
                        </div>

                    </div>
                    <div className="col-md-4">
                        <div>

                            <div className="bg-light-gray p-2 mb-4 input-container">
                                <h4 className="headline headline-xs mb-2">{translateResourceString("/MyAccountPage/InvoicePayments/Payments/NotesHeader")}</h4>
                                <textarea
                                    className="form-control mb-4"
                                    onChange={(e) => this.setState({ notes: e.target.value })}
                                    value={notes}
                                />
                            </div>


                            <div className="bg-light-gray p-2">
                                <h4 className="headline headline-xs mb-2">{translateResourceString("/MyAccountPage/InvoicePayments/Payments/PaymentSummaryHeader")}</h4>
                                <div className="row mb-1">
                                    <div className="col">{translateResourceString("/MyAccountPage/InvoicePayments/Payments/InvoicesTotalLabel")}</div>
                                    <div className="col-auto">{printCurrency(invoicesTotal)}</div>
                                </div>
                                {surcharge > 0 && <div className="row mb-1">
                                    <div className="col">{translateResourceString("/MyAccountPage/InvoicePayments/Payments/SurchargeLabel")}</div>
                                    <div className="col-auto">{printCurrency(surcharge)}</div>
                                </div>}
                                <div className="row mb-4">
                                    <div className="col">{translateResourceString("/MyAccountPage/InvoicePayments/Payments/TotalLabel")}</div>
                                    <div className="col-auto">{printCurrency(total)}</div>
                                </div>
                                {paymentButtonText != null && paymentButtonText.length > 0 && <div className='payment-text'>{paymentButtonText}</div>}
                                <button
                                    className="btn btn-cc-black w-100"
                                    disabled={!paymentIsValid || paymentProcessing}
                                    onClick={() => this.processPayment(
                                        braintreePaymentNonce,
                                        selectedBraintreeAchBankAccount,
                                        braintreeDeviceData,
                                        invoicesTotal === 0 ? invoiceCredit : selectedPaymentType,
                                        selectedPaymentType === creditCard && !vaulted ? billingAddress : null,
                                        vaulted,
                                        braintreeSaveCard
                                    )}>{translateResourceString("/MyAccountPage/InvoicePayments/Payments/ProcessPaymentsButton")} {paymentProcessing && <span className="fas fa-spinner fa-spin" />}</button>
                            </div>

                        </div>
                    </div>
                </div>

            </div>

        );
    }
}

export default InvoicePayments;